import { motion } from "framer-motion";
import { Reveal, EASE } from "./Reveal";

export default function ApproachFlow({ steps }) {
  return (
    <div className="relative" data-testid="approach-flow">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-line/70 md:hidden" />
      <motion.div
        className="absolute left-[7px] top-2 bottom-2 w-px origin-top bg-glow/70 md:hidden"
        initial={{ scaleY: 0 }}
        whileInView={{ scaleY: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 2.2, ease: EASE }}
      />
      <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-line/70 md:block" />
      <motion.div
        className="absolute left-0 right-0 top-[7px] hidden h-px origin-left bg-glow/70 md:block"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 2.4, ease: EASE }}
        data-testid="approach-flow-line"
      />
      <ol
        className={`grid grid-cols-1 gap-12 md:gap-8 ${
          steps.length === 4 ? "md:grid-cols-4" : steps.length === 5 ? "md:grid-cols-5" : "md:grid-cols-3"
        }`}
      >
        {steps.map((s, i) => (
          <li key={s.n} className="relative pl-10 md:pl-0 md:pt-12">
            <motion.span
              className="absolute left-0 top-1 h-[15px] w-[15px] rounded-full border border-glow/70 bg-ink md:top-0"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: 0.35 + i * 0.35, ease: EASE }}
            >
              <span className="absolute inset-[4px] rounded-full bg-glow/80" />
            </motion.span>
            <Reveal delay={0.3 + i * 0.3}>
              <p className="font-mono text-[11px] tracking-[0.3em] text-glow/80">{s.n}</p>
              <h3 className="mt-3 font-mono text-sm uppercase tracking-[0.22em] text-slate-100">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.text}</p>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  );
}
